import { render, staticRenderFns } from "./faultReport.vue?vue&type=template&id=a1033d52&scoped=true"
import script from "./faultReport.vue?vue&type=script&lang=js"
export * from "./faultReport.vue?vue&type=script&lang=js"
import style0 from "./faultReport.vue?vue&type=style&index=0&id=a1033d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1033d52",
  null
  
)

export default component.exports